const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnbilledAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0976563,0,0,0.0976563,2.49995,2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.733,0L79.267,0C70.983,0 64.267,6.716 64.267,15L64.369,400.706C64.37,404.683 65.95,408.497 68.762,411.309L165.06,507.607C167.873,510.42 171.688,512 175.667,512L432.734,512C441.018,512 447.734,505.284 447.734,497L447.734,15C447.733,6.716 441.018,0 432.733,0ZM160.667,460.787L115.48,415.6L160.667,415.6L160.667,460.787ZM417.733,482L190.667,482L190.667,400.6C190.667,392.316 183.951,385.6 175.667,385.6L94.267,385.6L94.267,30L417.734,30L417.734,482L417.733,482Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.533,351.333L223.866,351.333C232.15,351.333 238.866,344.617 238.866,336.333C238.866,328.049 232.15,321.333 223.866,321.333L143.533,321.333C135.249,321.333 128.533,328.049 128.533,336.333C128.533,344.617 135.249,351.333 143.533,351.333Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.533,287.067L223.866,287.067C232.15,287.067 238.866,280.351 238.866,272.067C238.866,263.783 232.15,257.067 223.866,257.067L143.533,257.067C135.249,257.067 128.533,263.783 128.533,272.067C128.533,280.351 135.249,287.067 143.533,287.067Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.133,287.067L368.466,287.067C376.75,287.067 383.466,280.351 383.466,272.067C383.466,263.783 376.75,257.067 368.466,257.067L288.133,257.067C279.849,257.067 273.133,263.783 273.133,272.067C273.133,280.351 279.849,287.067 288.133,287.067Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,61.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.133,287.067L368.466,287.067C376.75,287.067 383.466,280.351 383.466,272.067C383.466,263.783 376.75,257.067 368.466,257.067L288.133,257.067C279.849,257.067 273.133,263.783 273.133,272.067C273.133,280.351 279.849,287.067 288.133,287.067Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.584806,0,0,0.570686,119.878,10.8277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,151C280.813,151 301,171.187 301,196C301,204.284 307.716,211 316,211C324.284,211 331,204.284 331,196C331,154.645 297.355,121 256,121C214.645,121 181,154.645 181,196L181,241L166,241C157.716,241 151,247.716 151,256C151,264.284 157.716,271 166,271L181,271C180.733,272.404 184.046,306.742 155.394,335.393C145.976,344.81 152.646,361 166,361L316,361C324.284,361 331,354.284 331,346C331,337.716 324.284,331 316,331L196.061,331C212.693,301.422 210.859,272.163 211,271L256,271C264.284,271 271,264.284 271,256C271,247.716 264.284,241 256,241L211,241L211,196C211,171.187 231.187,151 256,151Z",
    style: {
      fill: "rgb(214,57,29)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbilledAmount);
export default __webpack_public_path__ + "static/media/unbilled-amount.cfdc984fbf06e9b319f0a25c04d3261e.svg";
export { ForwardRef as ReactComponent };